
const map = {
    name: "1_3",
    mapType: "surface",
    mapBoundaries: {
        min: {x: 0, y: 4},
        max: {x: 15, y: 14}
    },
    items: [],
    overworld: [
        // bottom right wall
        {name: "green_bush", coordinates: {x: 9, y: 11}},
        {name: "green_bush", coordinates: {x: 10, y: 11}},
        {name: "green_bush", coordinates: {x: 11, y: 11}},
        {name: "green_bush", coordinates: {x: 12, y: 11}},
        {name: "green_bush", coordinates: {x: 13, y: 11}},
        {name: "green_bush", coordinates: {x: 14, y: 11}},
        {name: "green_bush", coordinates: {x: 15, y: 11}},
        {name: "green_bush", coordinates: {x: 9, y: 12}},
        {name: "green_bush", coordinates: {x: 10, y: 12}},
        {name: "green_bush", coordinates: {x: 11, y: 12}},
        {name: "green_bush", coordinates: {x: 12, y: 12}},
        {name: "green_bush", coordinates: {x: 13, y: 12}},
        {name: "green_bush", coordinates: {x: 14, y: 12}},
        {name: "green_bush", coordinates: {x: 15, y: 12}},
        {name: "green_bush", coordinates: {x: 9, y: 13}},
        {name: "green_bush", coordinates: {x: 10, y: 13}},
        {name: "green_bush", coordinates: {x: 11, y: 13}},
        {name: "green_bush", coordinates: {x: 12, y: 13}},
        {name: "green_bush", coordinates: {x: 13, y: 13}},
        {name: "green_bush", coordinates: {x: 14, y: 13}},
        {name: "green_bush", coordinates: {x: 15, y: 13}},
        {name: "green_bush", coordinates: {x: 9, y: 14}},
        {name: "green_bush", coordinates: {x: 10, y: 14}},
        {name: "green_bush", coordinates: {x: 11, y: 14}},
        {name: "green_bush", coordinates: {x: 12, y: 14}},
        {name: "green_bush", coordinates: {x: 13, y: 14}},
        {name: "green_bush", coordinates: {x: 14, y: 14}},
        {name: "green_bush", coordinates: {x: 15, y: 14}},

        // vertical shoreline
        {name: "shoreline_up_left", coordinates: {x: 6, y: 9}},
        {name: "shoreline_up_left", coordinates: {x: 6, y: 10}},
        {name: "shoreline_up_left", coordinates: {x: 6, y: 11}},
        {name: "shoreline_up_left", coordinates: {x: 6, y: 12}},
        {name: "shoreline_up_left", coordinates: {x: 6, y: 13}},
        {name: "shoreline_up_left", coordinates: {x: 6, y: 14}},

        // shoreline curve
        {name: "river0", coordinates: {x: 6, y: 8}},
        {name: "river_bank_up_right", coordinates: {x: 7, y: 8}},
        {name: "river0", coordinates: {x: 7, y: 7}},
        {name: "river0", coordinates: {x: 6, y: 7}},

        // horizontal shoreline
        {name: "shoreline_bottom", coordinates: {x: 8, y: 7}},
        {name: "shoreline_bottom", coordinates: {x: 9, y: 7}},
        {name: "shoreline_bottom", coordinates: {x: 10, y: 7}},
        {name: "shoreline_bottom", coordinates: {x: 11, y: 7}},
        {name: "shoreline_bottom", coordinates: {x: 12, y: 7}},
        {name: "shoreline_bottom", coordinates: {x: 13, y: 7}},
        {name: "shoreline_bottom", coordinates: {x: 14, y: 7}},
        {name: "shoreline_bottom", coordinates: {x: 15, y: 7}},

        // ocean bottom left
        {name: "river0", coordinates: {x: 0, y: 7}},
        {name: "river0", coordinates: {x: 1, y: 7}},
        {name: "river0", coordinates: {x: 2, y: 7}},
        {name: "river0", coordinates: {x: 3, y: 7}},
        {name: "river0", coordinates: {x: 4, y: 7}},
        {name: "river0", coordinates: {x: 5, y: 7}},
        {name: "river0", coordinates: {x: 0, y: 8}},
        {name: "river0", coordinates: {x: 1, y: 8}},
        {name: "river0", coordinates: {x: 2, y: 8}},
        {name: "river0", coordinates: {x: 3, y: 8}},
        {name: "river0", coordinates: {x: 4, y: 8}},
        {name: "river0", coordinates: {x: 5, y: 8}},
        {name: "river0", coordinates: {x: 0, y: 9}},
        {name: "river0", coordinates: {x: 1, y: 9}},
        {name: "river0", coordinates: {x: 2, y: 9}},
        {name: "river0", coordinates: {x: 3, y: 9}},
        {name: "river0", coordinates: {x: 4, y: 9}},
        {name: "river0", coordinates: {x: 5, y: 9}},
        {name: "river0", coordinates: {x: 0, y: 10}},
        {name: "river0", coordinates: {x: 1, y: 10}},
        {name: "river0", coordinates: {x: 2, y: 10}},
        {name: "river0", coordinates: {x: 3, y: 10}},
        {name: "river0", coordinates: {x: 4, y: 10}},
        {name: "river0", coordinates: {x: 5, y: 10}},
        {name: "river0", coordinates: {x: 0, y: 11}},
        {name: "river0", coordinates: {x: 1, y: 11}},
        {name: "river0", coordinates: {x: 2, y: 11}},
        {name: "river0", coordinates: {x: 3, y: 11}},
        {name: "river0", coordinates: {x: 4, y: 11}},
        {name: "river0", coordinates: {x: 5, y: 11}},
        {name: "river0", coordinates: {x: 0, y: 12}},
        {name: "river0", coordinates: {x: 1, y: 12}},
        {name: "river0", coordinates: {x: 2, y: 12}},
        {name: "river0", coordinates: {x: 3, y: 12}},
        {name: "river0", coordinates: {x: 4, y: 12}},
        {name: "river0", coordinates: {x: 5, y: 12}},
        {name: "river0", coordinates: {x: 0, y: 13}},
        {name: "river0", coordinates: {x: 1, y: 13}},
        {name: "river0", coordinates: {x: 2, y: 13}},
        {name: "river0", coordinates: {x: 3, y: 13}},
        {name: "river0", coordinates: {x: 4, y: 13}},
        {name: "river0", coordinates: {x: 5, y: 13}},
        {name: "river0", coordinates: {x: 0, y: 14}},
        {name: "river0", coordinates: {x: 1, y: 14}},
        {name: "river0", coordinates: {x: 2, y: 14}},
        {name: "river0", coordinates: {x: 3, y: 14}},
        {name: "river0", coordinates: {x: 4, y: 14}},
        {name: "river0", coordinates: {x: 5, y: 14}},

        // ocean top
        {name: "river0", coordinates: {x: 0, y: 4}},
        {name: "river0", coordinates: {x: 1, y: 4}},
        {name: "river0", coordinates: {x: 2, y: 4}},
        {name: "river0", coordinates: {x: 3, y: 4}},
        {name: "river0", coordinates: {x: 4, y: 4}},
        {name: "river0", coordinates: {x: 5, y: 4}},
        {name: "river0", coordinates: {x: 6, y: 4}},
        {name: "river0", coordinates: {x: 7, y: 4}},
        {name: "river0", coordinates: {x: 8, y: 4}},
        {name: "river0", coordinates: {x: 9, y: 4}},
        {name: "river0", coordinates: {x: 10, y: 4}},
        {name: "river0", coordinates: {x: 11, y: 4}},
        {name: "river0", coordinates: {x: 12, y: 4}},
        {name: "river0", coordinates: {x: 13, y: 4}},
        {name: "river0", coordinates: {x: 14, y: 4}},
        {name: "river0", coordinates: {x: 15, y: 4}},
        {name: "river0", coordinates: {x: 0, y: 5}},
        {name: "river0", coordinates: {x: 1, y: 5}},
        {name: "river0", coordinates: {x: 2, y: 5}},
        {name: "river0", coordinates: {x: 3, y: 5}},
        {name: "river0", coordinates: {x: 4, y: 5}},
        {name: "river0", coordinates: {x: 5, y: 5}},
        {name: "river0", coordinates: {x: 6, y: 5}},
        {name: "river0", coordinates: {x: 7, y: 5}},
        {name: "river0", coordinates: {x: 8, y: 5}},
        {name: "river0", coordinates: {x: 9, y: 5}},
        {name: "river0", coordinates: {x: 10, y: 5}},
        {name: "river0", coordinates: {x: 11, y: 5}},
        {name: "river0", coordinates: {x: 12, y: 5}},
        {name: "river0", coordinates: {x: 13, y: 5}},
        {name: "river0", coordinates: {x: 14, y: 5}},
        {name: "river0", coordinates: {x: 15, y: 5}},
        {name: "river0", coordinates: {x: 0, y: 6}},
        {name: "river0", coordinates: {x: 1, y: 6}},
        {name: "river0", coordinates: {x: 2, y: 6}},
        {name: "river0", coordinates: {x: 3, y: 6}},
        {name: "river0", coordinates: {x: 4, y: 6}},
        {name: "river0", coordinates: {x: 5, y: 6}},
        {name: "river0", coordinates: {x: 6, y: 6}},
        {name: "river0", coordinates: {x: 7, y: 6}},
        {name: "river0", coordinates: {x: 8, y: 6}},
        {name: "river0", coordinates: {x: 9, y: 6}},
        {name: "river0", coordinates: {x: 10, y: 6}},
        {name: "river0", coordinates: {x: 11, y: 6}},
        {name: "river0", coordinates: {x: 12, y: 6}},
        {name: "river0", coordinates: {x: 13, y: 6}},
        {name: "river0", coordinates: {x: 14, y: 6}},
        {name: "river0", coordinates: {x: 15, y: 6}},

    ]
}

export default map
